import { DocumentStatus } from '../../enums/data.enums';

// Where an attachment came from. Both ultimately reference a Document Center file, but the source
// changes the add flow (browse a Public folder vs. upload into the Email Attachments folder).
export enum AttachmentSource {
    DocumentCenter = 'documentCenter',
    Upload = 'upload'
}

// A file chosen as an email attachment and shown in the composer's list. Every attachment resolves to
// a committed Document Center file, so only its id is sent to the API.
export interface EmailAttachmentItem {
    documentId: number;
    name: string;
    sizeBytes: number;
    source: AttachmentSource;
    // Document Center virus-scan lifecycle: a freshly uploaded file is Pending until the scan clears
    // (Available) or blocks it (Quarantined). Files picked from an existing folder are already Available.
    status?: DocumentStatus;
}

// Emitted to the page whenever the attachment set (or upload activity) changes.
export interface AttachmentSelectionState {
    attachments: EmailAttachmentItem[];
    totalBytes: number;
    // Attachments are optional, so an empty set is valid; this only flags the combined-size ceiling
    // being exceeded (a defensive guard — the component blocks over-limit adds up front).
    isWithinLimit: boolean;
    // A device upload is still committing. The page blocks Send while true so a file can't be left off
    // the blast by sending before it finishes.
    isUploading: boolean;
}
